import React from "react";
import { defineMessages } from "react-intl";

import { useUpdateCredentials } from "@/api/verification";
import { useAuth } from "@/contexts/auth/useAuth";
import toast from "@/toast";

import ThemeSelector from "./theme-selector";

const messages = defineMessages({
  saveSuccess: {
    id: "settings.save.success",
    defaultMessage: "Your preferences have been saved!",
  },
});

/** Stateful theme selector. */
const ThemeToggle: React.FC = () => {
  const { currentAccount } = useAuth();
  const updateCredentials = useUpdateCredentials();

  const themeMode = currentAccount?.settings?.themeMode;

  const handleChange = (themeMode: string) => {
    const currentSettings = currentAccount?.pleroma?.settings_store?.soapbox_fe;

    updateCredentials.mutate(
      {
        pleroma_settings_store: {
          soapbox_fe: {
            ...currentSettings,
            themeMode,
          },
        },
      },
      {
        onSuccess() {
          toast.success(messages.saveSuccess);
        },
      },
    );
  };

  return <ThemeSelector value={themeMode as string} onChange={handleChange} />;
};

export default ThemeToggle;
